export default {
  primary: '#0984e3',
  disabled: '#B7B7B7'
};



// WEBPACK FOOTER //
// ./src/utils/colors.js